import React, { createContext, useState, useContext } from 'react';
import { useNotification } from '../contexts/NotificationContext';
import ProjectService, { DataLabelingProjectModel } from '../services/ProjectService';
import { CommonLibrary } from './CommonContext';

interface ProjectContextType {
    projects: DataLabelingProjectModel[];
    //selectedProject: ProjectModel | undefined;
   // setSelectedProject: React.Dispatch<React.SetStateAction<ProjectModel | undefined>>;
    loadProjects: () => Promise<DataLabelingProjectModel[] | undefined>;
    checkProjectConfiguration: () =>  Promise<boolean>;
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined);

export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [projects, setProjects] = useState<DataLabelingProjectModel[]>([]);
    const projectServiceInstance = new ProjectService();
    const notifications = useNotification();
    const comonLibrary = new CommonLibrary();

    // This function loads the projects from the API and sets them in the state and in session storage
    const loadProjects = async (): Promise<DataLabelingProjectModel[] | undefined> => {
        let projectItems: DataLabelingProjectModel[] | undefined;
        try {
             projectItems = await projectServiceInstance.GetMyProjects();
            setProjects(projectItems);

            if (projectItems.length > 0) {
                let projectId = comonLibrary.ProjectId;
                sessionStorage.setItem('projects', JSON.stringify(projectItems));
                let activeProj = projectItems.find(p => p.Id === projectId) || projectItems[0];
                sessionStorage.setItem('activeProject', JSON.stringify(activeProj));
                localStorage.setItem('projectId', activeProj.Id.toString());
                
            } 
            else {
                notifications.showNotification("You don't have active projects", "warning");
            }
        } catch (error) {
            console.error('Error fetching projects:', error);
            notifications.showNotification("Error loading Projects " + error, "error");
        }
        return projectItems;
    };
    // Check in session storage if there are projects and active project. If not, load them
    const checkProjectConfiguration = async () => {
        // If there are no projects or active project, load them
        if (comonLibrary.UserProjects.length === 0 || !comonLibrary.ActiveProject) {
           await loadProjects();
           return true
        }
        else{
            return false;
        }
        
        
    };

    return (
        <ProjectContext.Provider value={{ projects, loadProjects, checkProjectConfiguration}}>
            {children}
        </ProjectContext.Provider>
    );
};

export const useProjectContext = () => {
    const context = useContext(ProjectContext);
    if (!context) {
        throw new Error('useProjectContext must be used within a ProjectProvider');
    }
    return context;
};
